import {
	ShouldLaunchApp,
	ShouldLaunchAppClip,
	launchApp,
	launchAppClip,
	ShouldAppClipsLaunchViaAppleLinks,
} from './Core'
import{ Metrics, Page } from './Metrics'
import{ RegionVM } from './Models/RegionVM'
import{ initAppsWidget } from './Shared/AppsWidget'

//
// region constants
//

declare const _region:RegionVM|null

// endregion


$( async function () {
	// init
	initAppsWidget( Page.LaunchPage )
	
	// metrics
	Metrics.logLaunchPageViewed( _region?.Identifier )

	// app launch
	// TODO(DRY): generalize across pages
	await Metrics.logAppClipsCapability()
	// console.debug( `ShouldLaunchApp: ${ShouldLaunchApp}` )
	// console.debug( `ShouldLaunchAppClip: ${ShouldLaunchAppClip}` )
	if( ShouldLaunchAppClip ){
		if( ShouldAppClipsLaunchViaAppleLinks ){
			/*NOTE: ignore async*/await launchAppClip()
		} else { /*do nothing – handled via <meta> param*/ }
	} else if( ShouldLaunchApp ){
		/*NOTE: ignore async*/await launchApp()
	}
})
